<div class="e-system-error-layout">
    <h1>
        <i class="fa-solid fa-circle-xmark"></i>
        System Error
    </h1>
    <h2>Oops! Something went wrong</h2>
    <p>
        The action you have tried to complete isn't available, or was processed incorrectly.<br />
        Please try again or <a href="{{helpPageUrl}}" target="_blank">contact us</a> if the error persists.
    </p>
</div>
